/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResourceInsert/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ResourceInsert({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/ResourceInsert"
  
}) {
  return null
}